import React from 'react';

import { Select } from '@aline/common';
import { PanelHeader, panelHeaderHeightPx } from 'src/components';
import { makeStyles } from 'tss-react/mui';

import { AddContentSection } from './AddContentSection';
import { useBackToAI } from '../../BackToAIButton';

const useStyles = makeStyles()(theme => ({
  inputsDrawerContainer: {
    backgroundColor: theme.palette.common.white,
    height: `calc(100% - ${panelHeaderHeightPx * 2}px)`,
    width: '100%',
  },
}));

export function AddInputPanel(): JSX.Element {
  const { classes } = useStyles();
  const handleBackToAI = useBackToAI();

  return (
    <>
      <PanelHeader
        showBackButton
        backButtonTooltip="Back to AI"
        text="Add Content"
        onClickBack={handleBackToAI}
      />
      <div
        className={classes.inputsDrawerContainer}
        data-cy={Select.document.editor.rightDrawer.addContentPanel.container}
      >
        <AddContentSection />
      </div>
    </>
  );
}
